<template>
  <span
    class="forex-currency-pair-currencies"
    :class="{'forex-currency-pair-currencies--medium': medium}"
  >
    <span class="t-buy-currency">{{ from }}</span>
    <v-icon
      class="forex-currency-pair-currencies__icon"
      :size="size"
    >sync_alt</v-icon>
    <span class="t-sell-currency">{{ to }}</span>
  </span>
</template>

<script>
  export default {
    name: 'ForexCurrencyPairCurrencies',
    props: {
      from: {
        required: true,
        type: String
      },
      to: {
        required: true,
        type: String
      },
      size: {
        type: [String, Number],
        default: 16
      },
      medium: {
        default: false,
        type: Boolean
      }
    }
  }
</script>

<style lang="scss">
  .forex-currency-pair-currencies {
    font-weight: 500;

    &--medium {
      font-weight: 400;
    }

    &__icon {
      position: relative;
      bottom: 1px;
      color: inherit !important;
    }
  }
</style>
